import { Menu } from 'models/admin/Menu';

export type LangType = 'ko' | 'en' | 'pl' | 'zhC' | 'zhT' | 'zh' | 'id';

export interface Session {
  userId?: string;

  empNm?: string;
  langCd?: LanguageCode;
  roleCodes?: string[];
  menus?: Menu[];
  gptTmzCd?: string;
  tmzFrmtCd?: string;
  prdnProcCd?: string; // [25.04.08] 공정추가
  mpClsfType?: string; // [25.04.08] MP분류추가

  userCopCd?: string;
  userDeptCd?: string;
  empNo?: string;
  empEngNm?: string;
  empCngNm?: string;
  deptCd?: string;
  deptNm?: string;
  deptEngNm?: string;
  deptCngNm?: string;
  copCd?: string;
  elmCopCd?: string;
  jtiCd?: string;
  jtiNm?: string;
  jtiEngNm?: string;
  jtiCngNm?: string;
  jpsCd?: string;
  jpsNm?: string;
  jpsEngNm?: string;
  jpsCngNm?: string;
  upprEmpNo?: string;
  upprUserId?: string;
  onduRegnCd?: string;
  onduRegnNm?: string;
  ctryCd?: string;
  teamYn?: string;
  tldYn?: string;
  leasTeamYn?: string;
  leasTldYn?: string;
  gleasTeamYn?: string;
  gleasTldYn?: string;
  mgrDeptCd?: string;
  ensolYn?: string; // [25.11.19] 엔솔사용자여부 추가
  elmPrjId: string; // [25.12.08] FA 프로젝트 추가
}

export enum LanguageCode {
  ko = 'ko',
  en = 'en',
  pl = 'pl',
  zhC = 'zhC',
  zhT = 'zhT',
  zh = 'zh',
  id = 'id',
}

export enum GridNoRowsTemplateData {
  ko = '<div class="agNodata"><span>조회 가능한 데이터가 없습니다.</span></div>',
  en = '<div class="agNodata"><span>There is no data available to view.</span></div>',
  pl = '<div class="agNodata"><span>Brak danych do wyświetlenia.</span></div>',
  zhC = '<div class="agNodata"><span>没有可查看的数据。</span></div>',
  zhT = '<div class="agNodata"><span>没有可供查看的数据。</span></div>',
  zh = '<div class="agNodata"><span>没有可查看的数据。</span></div>',
  id = '<div class="agNodata"><span>There is no data available to view.</span></div>',
}
